import { Schema } from "effect";

import { isValidBase64Pem } from "../utils/pem";

/** Email field with validation */
export const Email = Schema.String.pipe(
  Schema.check(
    Schema.isPattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, {
      message: "Invalid email address",
    })
  )
);

/** Non-empty string field */
export const NonEmptyString = Schema.String.pipe(
  Schema.check(
    Schema.isMinLength(1, {
      message: "This field is required",
    })
  )
);

/** Password field with minimum length validation */
export const Password = Schema.String.pipe(
  Schema.check(
    Schema.isMinLength(8, {
      message: "Password must be at least 8 characters",
    })
  )
);

/** Name field with minimum length validation */
export const Name = Schema.String.pipe(
  Schema.check(
    Schema.isMinLength(1, {
      message: "Name is required",
    })
  )
);

/** Organization/Project name field with minimum length validation */
export const EntityName = Schema.String.pipe(
  Schema.check(
    Schema.isMinLength(3, {
      message: "Name must be at least 3 characters",
    })
  )
);

/** URL field with validation */
export const Url = Schema.String.pipe(
  Schema.check(
    Schema.makeFilter(
      (s) => {
        try {
          new URL(s);
          return true;
        } catch {
          return false;
        }
      },
      { message: "Invalid URL format" }
    )
  )
);

/** Sentry DSN field - accepts valid URL or empty string */
export const SentryDsn = Schema.Union([
  Url,
  Schema.Literal(""),
]);

/** Base64-encoded PEM key field with validation */
export const Base64Pem = Schema.String.pipe(
  Schema.check(
    Schema.makeFilter(isValidBase64Pem, {
      message: "Invalid base64-encoded PEM format",
    })
  )
);
